module.exports = __webpack_public_path__ + "static/media/puzzleIcon.7a54d495.svg";